import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { TinaMarkdown as TinaMarkdownComp } from "tinacms/dist/rich-text";
import { tinaField as TinaField } from "tinacms/dist/tina-field";

import { getSiteUrl } from "@/lib/site-url";

export { useTina } from "./use-tina";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const tinaField = TinaField;
export const TinaMarkdown = TinaMarkdownComp;

const DEFAULT_SEO = {
  title: "Slan Docs",
  description: "Digital equipment documentation and compliance management built for construction",
};

export const defaultMetadata = DEFAULT_SEO;

export function formatMetadata({ seo = {}, pagePath = "/" }) {
  return {
    title: seo?.title ? `${seo?.title} | Slan Docs` : "Slan Docs",
    description: seo?.description || DEFAULT_SEO.description,
    keywords: seo?.keywords || "",
    alternates: {
      canonical: pagePath,
    },
    openGraph: {
      type: "website",
      siteName: "Slan Docs",
      title: seo?.title ? `${seo?.title} | Slan Docs` : "Slan Docs",
      description: seo?.description || DEFAULT_SEO.description,
      url: `${getSiteUrl()}${pagePath}`,
    },
  };
}
